import React, { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { IoCloseSharp, BsImages } from "../../components/utils/icons";
import { useStateContext } from '../../context/ContextProvider';
import { TextQill } from './utils';
import { DLabel, Select, DSpinButton, TextArea } from '../utils/Form';
import { getAllCategorys } from '../../redux/actions/category';
import { toast } from 'react-toastify';
import { Loader } from '../utils';
import { use } from 'react';
import { BaseUrl } from '../../server';
function CreateReview() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();

  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
  const [titleAr, setTitleAr] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [textEn, setTextEn] = useState("");

  const [textAr, setTextAr] = useState("");
  const [date ,setDate]=useState("")
  const [image, setImage] = useState();
  const [imageShow, setImageShow] = useState();
  


  const inmageHandle = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
      const imageUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setImageShow(imageUrl);
    }
  };

  const changeImage = (img) => {
    if (img) {
      const tempUrl = { url: URL.createObjectURL(img) }; // كائن مباشر
      setImageShow(tempUrl);
      setImage(img);
    }
  };

  const removeImage = () => {
    setImage();
    setImageShow();
  };

  const CreatereviewFunc = async (newForm) => {
    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } ,withCredentials: true  };
        const { data } = await axios.post(`${BaseUrl}/reviews/create`, newForm, config );
        if(data.success){
        // عرض رسالة نجاح
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Review created successfully!")}</span>);

        // إعادة تعيين الحالات
        setIsSpinner(false);
        setTitleAr("");
        setTitleEn("");
        setTextAr("");
        setTextEn("");
     
        setDate("");
        setImage("");
        setImageShow(""); // تأكد من أن هذه الدالة موجودة وتعمل بشكل صحيح
        }
    } catch (error) {
        // عرض رسالة خطأ
        toast.error(error.response?.data?.message);
        setIsSpinner(false);
    }
};
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
    const newForm = new FormData();
    newForm.append("file", image);

    newForm.append("date", date);
    newForm.append("titleAr", titleAr);
    newForm.append("titleEn", titleEn);
    newForm.append("textAr", textAr);
    newForm.append("textEn", textEn);
  
    CreatereviewFunc(newForm)

  };

  return (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
        <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
          {t("Create Review")}
        </h3>
        <form onSubmit={handleSubmit}>
          <br />
          <div>
        
          <DLabel
              labelText="Name (Ar)"
              value={titleAr}
              onChange={(e)=> {setTitleAr(e.target.value)}}
              required={true}
              type="text"
              name="titleAr"
            />
             <DLabel
              labelText="Name (En)"
              value={titleEn}
              onChange={(e)=> {setTitleEn(e.target.value)}}
              required={true}
              type="text"
              name="titleAr"
            />
            <DLabel
              labelText="Date"
              value={date}
              onChange={(e)=> {setDate(e.target.value)}}
              required={true}
              type="date"
              name="Date"
            />
          
          <TextArea labelText={t("Description (Ar)")} value={textAr} onChange={(e) => setTextAr(e.target.value)} required={true} />
 <TextArea labelText={t("Description (En)")} value={textEn} onChange={(e) => setTextEn(e.target.value)} required={true} />
  <label  className="pb-2 text-tcolor-5  text-md font-kufi"> 
              {t("Upload Image")}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              name=""
              id="upload"
              className="hidden"
              onChange={inmageHandle}
            />
  
            {imageShow ? (
              <div className="h-[180px] relative">
                <label htmlFor="0">
                  <img
                    className="w-full h-full rounded-lg border"
                    src={imageShow.url} // الوصول إلى url مباشرةً
                    alt=""
                    style={{
                      borderColor: currentColor,
                    }}
                  />
                </label>
                <input
                  onChange={(e) => changeImage(e.target.files[0])}
                  type="file"
                  id="0"
                  className="hidden"
                />
                <span
                  onClick={removeImage}
                  className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
                  style={{ backgroundColor: currentColor }}
                >
                  <IoCloseSharp />
                </span>
              </div>
            ) : (
              <label
                className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
                htmlFor="image"
                style={{
                  borderColor: currentColor,
                }}
              >
                <span>
                  <BsImages size={40} color={currentColor} />
                </span>
                <span
                className="pb-2 text-color-1  text-md font-kufi"
              
                >
                  {t("Select Image")}
                </span>
              </label>
            )}
  
            <input
              onChange={inmageHandle}
              className="hidden"
              type="file"
              id="image"
            />
            <br />
          </div>
          <DSpinButton isLoading={isSpinner}>{t("Create")}</DSpinButton>
        </form>
      </div>
  

  );
}

export default CreateReview;